import { render, staticRenderFns } from "./show-price.vue?vue&type=template&id=fb2f5be2&scoped=true"
import script from "./show-price.vue?vue&type=script&lang=js"
export * from "./show-price.vue?vue&type=script&lang=js"
import style0 from "./show-price.vue?vue&type=style&index=0&id=fb2f5be2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2f5be2",
  null
  
)

export default component.exports